module.exports = __webpack_public_path__ + "img/stock5.3e197203.png";